// Config central del widget (loader + iframe). Único punto a cambiar para
// migrar de infra. esbuild inlinea este módulo en cada bundle (v1.js IIFE +
// frame.js ESM), así no hay runtime fetch ni acoplamiento entre los dos.
//
// FUTURO: cuando exista widget.yatendi.com (ACM + Route53), cambiar acá
// API_BASE y listo — el CDN_BASE del loader se deriva solo del src del
// <script>, así que ese no se hardcodea.
//
// Hardcoded por ahora (slice 1d-bis). Migrar a un define de esbuild
// (process.env inyectado en build.mjs) cuando haya stage dev/prod separados.

/** Base del HTTP API del widget (stage prod). */
export const API_BASE =
  "https://6v15qddr0l.execute-api.us-east-2.amazonaws.com/prod";
